"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _documentOffset = _interopRequireDefault(require("document-offset"));

var _mergeTheme = _interopRequireDefault(require("../style/mergeTheme"));

var _root = _interopRequireDefault(require("./style/root"));

var _icon = _interopRequireDefault(require("./style/icon"));

var _form = _interopRequireDefault(require("./style/form"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var ErrorComponent = function ErrorComponent(_ref) {
  var minOffsetTop = _ref.minOffsetTop,
      theme = _ref.theme,
      style = _ref.style,
      type = _ref.type,
      name = _ref.name,
      children = _ref.children,
      className = _ref.className;
  var root = (0, _react.useRef)(null);
  var setPosition = (0, _react.useCallback)(function () {
    if (root.current) {
      var position = (0, _documentOffset["default"])(root.current),
          scroll = window.scrollY;

      if (typeof root.current.scrollIntoView === 'function' && (position === null || position === void 0 ? void 0 : position.top) < scroll + minOffsetTop) {
        root.current.scrollIntoView({
          block: 'center',
          behavior: 'smooth'
        });
      }
    }
  }, [root.current, minOffsetTop]);
  var memoTheme = (0, _react.useMemo)(function () {
    var merged = (0, _mergeTheme["default"])(theme, style);
    merged.field = _objectSpread({}, merged, {}, merged.field);
    merged.form = _objectSpread({}, merged, {}, merged.form);
    merged.service = _objectSpread({}, merged, {}, merged.service);
    merged.global = _objectSpread({}, merged, {}, merged.global);
    return merged;
  }, [style]);
  (0, _react.useEffect)(function () {
    return setPosition();
  }, [root.current]);
  var additionalClass = type === 'field' && name ? "".concat(name, "-error") : '';
  var content;
  var icon = (0, _react.useMemo)(function () {
    var palette = memoTheme.palette;

    if (typeof memoTheme.warningIcon === 'string') {
      return _react["default"].createElement("img", {
        src: memoTheme.warningIcon,
        width: palette.gutter * 3,
        height: palette.gutter * 3,
        alt: "error"
      });
    } else if (typeof memoTheme.warningIcon === 'function') {
      return _react["default"].createElement(memoTheme.warningIcon, {
        width: palette.gutter * 3,
        height: palette.gutter * 3,
        fill: palette.elError
      });
    } else {
      return memoTheme.warningIcon;
    }
  }, [memoTheme.warningIcon]);

  if (type === 'form') {
    content = _react["default"].createElement(_form["default"], null, _react["default"].createElement(_icon["default"], {
      theme: memoTheme
    }, icon), _react["default"].createElement("div", null, children));
  } else {
    content = children;
  }

  return _react["default"].createElement(_root["default"], {
    ref: root,
    theme: memoTheme[type],
    className: additionalClass + ' ' + className
  }, content);
};

ErrorComponent.defaultProps = {
  type: 'service',
  minOffsetTop: 90
};
ErrorComponent.propTypes = {
  type: _propTypes["default"].string,
  minOffsetTop: _propTypes["default"].number,
  theme: _propTypes["default"].shape({
    /**
     * @default palette.tError
     */
    color: _propTypes["default"].string,

    /**
     * @default left
     */
    textAlign: _propTypes["default"].string,

    /**
     * @default 0
     */
    paddingTop: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default 0
     */
    paddingBottom: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default 0
     */
    paddingLeft: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default 0
     */
    paddingRight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default palette.tsNormal
     */
    fontSize: _propTypes["default"].string,

    /**
     * @default palette.tlNormal
     */
    lineHeight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default palette.twNormal
     */
    fontWeight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default auto
     */
    margin: _propTypes["default"].string,

    /**
     * @default transparent
     */
    background: _propTypes["default"].string,

    /**
     * @default warningIcon
     */
    warningIcon: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func, _propTypes["default"].object]),

    /**
     * @default override for field
     */
    field: _propTypes["default"].shape(),

    /**
     * @default override for form
     */
    form: _propTypes["default"].shape(),

    /**
     * @default override for service
     */
    service: _propTypes["default"].shape(),

    /**
     * @default override for service
     */
    global: _propTypes["default"].shape()
  })
};
var _default = ErrorComponent;
exports["default"] = _default;